export default "images/title.png";